import { render, staticRenderFns } from "./SifnfDashboard.vue?vue&type=template&id=e3739728&"
import script from "./SifnfDashboard.vue?vue&type=script&lang=js&"
export * from "./SifnfDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SifnfDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports